const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();

  return <div className="fixed bottom-0 right-0 text-gray-500">by cqdev apps {year}</div>;
};

export default Footer;
